export interface EditManualProductInTcUrlParams {
    projectId: number;
    userId: number;
    organizationId: string;
    productId: number;
    returnUrl: string;
}

/**
 * TC edit URL — same route as "Add not in TC", with `productId` for Craft prefill.
 * PB&L Edit uses a **single** browser GET here (no separate `/api/v1/products?ids=` call).
 * Query keys: `project`, `userId`, `organizationId`, `productId`, `return`.
 */
export function buildEditManualProductInTcUrl(params: EditManualProductInTcUrlParams): string {
    const query = new URLSearchParams({
        project: String(params.projectId),
        userId: String(params.userId),
        organizationId: String(params.organizationId),
        productId: String(params.productId),
        return: params.returnUrl,
    });
    return `${process.env.REACT_APP_TC_URL}/project-builder/add-product?${query.toString()}`;
}